// Main navigation

jQuery(document).ready(function($) {

  // Sticky nav
  $(window).scroll(function () {
    const header = $('div.homepage-header')

    if ($(window).scrollTop() > header.outerHeight()) {
      $('.header').addClass('sticky')
      $('.hide-logo').css({"opacity": "1"})
      $('.hide-logo').css({"width": "auto"})
      $('.hide-logo').css({"height": "auto"})
    }

    if ($(window).scrollTop() < header.outerHeight()) {
      $('.header').removeClass('sticky')
      $('.hide-logo').css({"opacity": "0"})
      $('.hide-logo').css({"width": "0"})
      $('.hide-logo').css({"height": "0"})
    }
  });

  // Remove active class from Contact link
  $('.off-canvas .menu .menu-item-176').removeClass('active')
})
